import React, { useContext, useState } from 'react';
// components
import FormProveedores from "./FormProveedores";
import FormB2BEmprendedores from "./FormB2BEmprendedores";
import AuthContext from '../../../../contexts/auth';
import { translate, verifyHideCountry, verifyHideCountryItems } from '../../../../utils/Common';
import TipoPaqueteSwitch from '../TipoPaqueteSwitch';
import { useLocation } from "react-router-dom";
import PageContainer from '../../../../components/layout/PageContainer';
import PageHeader from '../../../../components/layout/PageHeader';
import ContentCard from '../../../../components/layout/ContentCard';
import { FaCube } from 'react-icons/fa';
import { verifyAccessViewPermissions } from '../../../../config/permissions';
import { SegmentedControl } from '@/components/ui/segmented-control';

const CargaIndividual = () => {
    const UserContext = useContext(AuthContext);
    const [idTipoUsuario, setIdTipoUsuario] = useState(UserContext.user ? UserContext.user.IdTipoUsuario : 3);
    const [idTipoPaquete, setIdTipoPaquete] = useState(2); 

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const platformAutoSelect = queryParams.get('plt');

    const canCreate = verifyAccessViewPermissions(["create"], { path: location.pathname });
    const canSearch = verifyAccessViewPermissions(["search"], { path: location.pathname });
    
    return (
        <PageContainer>
            <PageHeader
                title={translate("sidebar.options.packages.loadpackage")}
                subtitle={translate("dashboard.packages.loadpackage.instructions")}
                icon={<FaCube size={24} />}
            />
            <ContentCard padding="md">
                
            <div className="flex flex-wrap items-start gap-x-8 gap-y-4">
                {verifyHideCountryItems(["pa"]) && (
                    <TipoPaqueteSwitch idTipoPaquete={idTipoPaquete} setIdTipoPaquete={setIdTipoPaquete} />
                )}

                {canSearch && UserContext.user?.IsAdmin && (
                    <SegmentedControl
                        name="tipoUsuario"
                        label={translate("dashboard.packages.loadpackage.selectedUser")}
                        value={idTipoUsuario}
                        onChange={setIdTipoUsuario}
                        options={[
                            // Provider and B2B intake only exist in PA.
                            ...(verifyHideCountry()
                                ? [
                                      { value: 1, label: translate("dashboard.packages.loadpackage.selectedUser.provider") },
                                      { value: 2, label: translate("dashboard.packages.loadpackage.selectedUser.b2b") },
                                  ]
                                : []),
                            { value: 3, label: translate("dashboard.packages.loadpackage.selectedUser.pymes") },
                        ]}
                    />
                )}
            </div>

            { idTipoUsuario === 1 ? 
                <FormProveedores
                    idTipoUsuario={ idTipoUsuario }
                    idTipoCliente={ idTipoUsuario > 1 ? 7 : 1 } 
                    idTipoPaquete={ idTipoPaquete }
                    idPlatformSelect={platformAutoSelect}
                    canCreate={canCreate}
                    canSearch={canSearch}/>
                :
                <FormB2BEmprendedores
                    idTipoUsuario={ idTipoUsuario }
                    idTipoCliente={ idTipoUsuario > 1 ? 7 : 1 }
                    idTipoPaquete={ idTipoPaquete }
                    idPlatformSelect={platformAutoSelect}
                    canCreate={canCreate}
                    canSearch={canSearch} />
            }
            </ContentCard>
        </PageContainer>
    );
}

export default CargaIndividual;